import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=2d3d9760&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=ts&"
export * from "./HeroSection.vue?vue&type=script&lang=ts&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=2d3d9760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d9760",
  null
  
)

export default component.exports